import { sheetConstants } from '../../../windows/constants/sheetConstants';
import { FontStyle, NumberFormat } from '../../types';
import {
  FormattedValue,
  getFormattedCell,
} from '../../utils/numberFormat/parser';

export const formatCellVisibleText = (
  isError: boolean,
  visibleValue: string,
  width: number,
  props: Partial<FontStyle> & Partial<NumberFormat> //
): Partial<FormattedValue> => {
  if (isError || !visibleValue.length || !props.code || !props.type) return {};

  const result = getFormattedCell(
    props.type,
    props.code,
    visibleValue,
    props.size ?? sheetConstants.cell.font.size,
    props.family ?? sheetConstants.cell.font.family,
    width
  );

  return result;
};
